<template>
  <div v-if="!loading">
    <form>
      <v-card
        v-if="form.spracovatelia"
        class="my-5"
      >
        <v-card-title>
          Spracovatelia ZVJS
        </v-card-title>
        <v-alert
          dense
          text
          color="info"
          icon="mdi-information-outline"
          class="ma-4"
        >
          <div class="text-caption">
            Táto sekcia slúži na definovanie prístupových práv pre používateľov z prostredia ZVJS.<br>
            <strong>Typ - Administrátor:</strong> Správa spracovateľov a kompletný prístup ku všetkým položkám formuláru<br>
            <strong>Typ - Spracovateľ:</strong> Kompletný prístup ku všetkým položkám formuláru<br>
            <strong>Typ - Externý spracovateľ:</strong> Prístup k vybraným položkám formuláru (bez základného čísla a obmedzení)
          </div>
        </v-alert>
        <v-card-text>
          <v-row
            v-for="(input, index1) in form.spracovatelia"
            :key="input.id"
            dense
          >
            <v-col>
              <v-autocomplete
                v-model="input.user"
                :disabled="form.closed"
                item-text="string_details"
                item-value="id"
                placeholder="Používateľ"
                label="Používateľ"
                :items="items_administrator[index1]"
                auto-select-first
                :search-input.sync="search_administrator[index1]"
                cache-items
                :loading="loading_administrator[index1]"
                hide-no-data
                append-icon="mdi-delete"
                @click:append="deleteRowSpracovatel(index1)"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.type"
                :items="select_administrator"
                label="Typ"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.pracovna_pozicia"
                :items="select_pracovna_pozicia"
                label="Pracovná pozícia"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="input.miesto"
                label="Miesto"
              />
            </v-col>
          </v-row>

          <v-btn
            text
            icon
            color="secondary"
            @click="addRow()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <v-card
        v-if="form.spracovatelia_upsvar"
        class="my-5"
      >
        <v-card-title>
          <v-icon left color="teal">mdi-account-group</v-icon>
          Spracovatelia ÚPSVaR
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="(input, index1) in form.spracovatelia_upsvar"
            :key="input.id"
            dense
          >
            <v-col>
              <v-autocomplete
                v-model="input.user"
                :disabled="form.closed"
                item-text="string_details"
                item-value="id"
                placeholder="Používateľ"
                label="Používateľ"
                :items="items_administrator_upsvar[index1]"
                auto-select-first
                :search-input.sync="search_administrator_upsvar[index1]"
                cache-items
                :loading="loading_administrator_upsvar[index1]"
                hide-no-data
                append-icon="mdi-delete"
                @click:append="deleteRowSpracovatelUPSVAR(index1)"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.type"
                :items="select_administrator_upsvar"
                label="Typ"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="input.pracovna_pozicia"
                :items="select_pracovna_pozicia"
                label="Pracovná pozícia"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="input.miesto"
                label="Miesto"
              />
            </v-col>
          </v-row>

          <v-btn
            text
            icon
            color="secondary"
            @click="addRowUPSVAR()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Form Actions -->
      <v-divider class="my-6" />
      <FormActions
        v-if="!form.closed"
        ref="formActions"
        :fixed="false"
        :is-dirty="isDirty"
        :loading="loading"
        save-text="Uložiť"
        @save="updateItem"
      />
    </form>

    <!-- Info Dialog -->
    </div>

  <div v-else>
    <form-skeleton-component skeleton_type="Spracovatelia" />
  </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from '@vue/composition-api';
import { useRoute } from '@/composables/useRouter.js';
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import FormActions from "@/components/FormActions.vue";
import { useIapszForm } from "@/composables/useIapszForm.js";
import { useFormDirty } from "@/composables/useFormDirty.js";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
    FormActions,
  },

  setup() {
    const route = useRoute();
    
    const { loading, setLoading, handleSaveSuccess, handleSaveError } = useIapszForm();
    const formActions = ref(null);
    
    const form = ref({
      id: null,
      closed: false,
      spracovatelia: [],
      spracovatelia_upsvar: [],
    });
    
    const initialForm = ref({});
    const { isDirty, markAsPristine, enableBrowserWarning } = useFormDirty(initialForm, form, { deep: true });
    enableBrowserWarning();
    
    const loading_administrator = ref([]);
    const search_administrator = ref([]);
    const loading_administrator_upsvar = ref([]);
    const search_administrator_upsvar = ref([]);
    const watchers = ref([]);
    const watchers_upsvar = ref([]);
    const items_administrator = ref([]);
    const items_administrator_upsvar = ref([]);

    const select_administrator = [
      { value: "Administrátor", text: "Administrátor" },
      { value: "Spracovateľ", text: "Spracovateľ" },
      { value: "Externý spracovateľ", text: "Externý spracovateľ" },
    ];

    const select_administrator_upsvar = [
      { value: "ÚPSVaR - administrátor", text: "ÚPSVaR - administrátor" },
      { value: "ÚPSVaR - spracovateľ", text: "ÚPSVaR - spracovateľ" },
    ];

    const select_pracovna_pozicia = [
      "Sociálny pracovník",
      "Psychológ",
      "Pedagóg",
      "Sociálny kurátor - metodik",
      "Sociálny kurátor - ÚPSVAR",
    ];

    const select_pracovna_pozicia_upsvar = [
      "ÚPSVaR - vedúci",
      "ÚPSVaR - kurátor",
    ];

    const manual = reactive({
      spracovatelia_zvjs: {
        nazov: "Spracovatelia ZVJS",
        priklady: [
          "Táto sekcia slúži na definovanie prístupových práv pre používateľov z prostredia ZVJS.",
          "Používateľ a typ sú povinné položky, pracovná pozícia a miesto sú nepovinné položky a slúžia na uľahčenie správy pri veľkom počte spracovateľov.",
          "Typ Administrátor: Správa spracovateľov a kompletný prístup ku všetkým položkám formuláru",
          "Typ Spracovateľ: Kompletný prístup ku všetkým položkám formuláru",
          "Typ Externý spracovateľ: Prístup k vybraným položkám formuláru (bez základného čísla a obmedzení)"
        ]
      },
      spracovatelia_upsvar: {
        nazov: "Spracovatelia ÚPSVaR",
        priklady: [
          "Táto sekcia slúži na definovanie prístupových práv pre používateľov z prostredia ÚPSVaR.",
          "Používateľ a typ sú povinné položky, pracovná pozícia a miesto sú nepovinné položky a slúžia na uľahčenie správy pri veľkom počte spracovateľov.",
          "Typ ÚPSVaR - administrátor: Správa spracovateľov a kompletný prístup ku všetkým položkám formuláru (v kontexte zmluvy o spolupráci)",
          "Typ ÚPSVaR - spracovateľ: Kompletný prístup ku všetkým položkám formuláru (v kontexte zmluvy o spolupráci)"
        ]
      },
    });
    
    // Initialize info dialog with manual data
    const querySelectionsAdministrator = (v, index) => {
      loading_administrator.value[index] = true;
      apiService.searchUsers(v).then((response) => {
        items_administrator.value[index] = response.results;
        loading_administrator.value[index] = false;
      });
    };

    const querySelectionsAdministratorUPSVAR = (v, index) => {
      loading_administrator_upsvar.value[index] = true;
      apiService.searchUsers(v).then((response) => {
        items_administrator_upsvar.value[index] = response.results;
        loading_administrator_upsvar.value[index] = false;
      });
    };

    const updateWatchersAnd = () => {
      if (form.value.spracovatelia) {
        for (let i = 0; i < form.value.spracovatelia.length; i++) {
          loading_administrator.value.push(false);
          search_administrator.value.push("");
          items_administrator.value.push([]);
          items_administrator.value[i].push(form.value.spracovatelia[i].user_full);
        }

        search_administrator.value.forEach((_, val) => {
          const unwatch = watch(
            () => search_administrator.value[val],
            (newVal) => {
              querySelectionsAdministrator(newVal, val);
            }
          );
          watchers.value.push(unwatch);
        });
      }

      if (form.value.spracovatelia_upsvar) {
        for (let i = 0; i < form.value.spracovatelia_upsvar.length; i++) {
          loading_administrator_upsvar.value.push(false);
          search_administrator_upsvar.value.push("");
          items_administrator_upsvar.value.push([]);
          items_administrator_upsvar.value[i].push(form.value.spracovatelia_upsvar[i].user_full);
        }

        search_administrator_upsvar.value.forEach((_, val) => {
          const unwatch = watch(
            () => search_administrator_upsvar.value[val],
            (newVal) => {
              querySelectionsAdministratorUPSVAR(newVal, val);
            }
          );
          watchers_upsvar.value.push(unwatch);
        });
      }
    };

    const getItem = () => {
      setLoading(true);
      apiService.getIapszForm(route.params.id).then((response) => {
        form.value = response;
        initialForm.value = JSON.parse(JSON.stringify(response));
        updateWatchersAnd();
        markAsPristine();
        setLoading(false);
      });
    };

    const updateItem = () => {
      apiService.updateIapszForm(form.value, route.params.id).then(
        (response) => {
          handleSaveSuccess();
          if (formActions.value) {
            formActions.value.showSuccess();
          }
          form.value = response;
          updateWatchersAnd();
          markAsPristine();
        },
        () => {
          handleSaveError();
          if (formActions.value) {
            formActions.value.showError();
          }
        }
      );
    };

    const addRow = () => {
      loading_administrator.value.push(false);
      search_administrator.value.push("");
      items_administrator.value.push([]);

      form.value.spracovatelia.push({
        user: null,
        iapsz: route.params.id,
        type: null,
      });

      const index = search_administrator.value.length - 1;
      watchers.value.push(
        watch(
          () => search_administrator.value[index],
          (newVal) => {
            querySelectionsAdministrator(newVal, index);
          }
        )
      );
    };

    const addRowUPSVAR = () => {
      loading_administrator_upsvar.value.push(false);
      search_administrator_upsvar.value.push("");
      items_administrator_upsvar.value.push([]);

      form.value.spracovatelia_upsvar.push({
        user: null,
        iapsz: route.params.id,
        type: null,
      });

      const index = search_administrator_upsvar.value.length - 1;
      watchers_upsvar.value.push(
        watch(
          () => search_administrator_upsvar.value[index],
          (newVal) => {
            querySelectionsAdministratorUPSVAR(newVal, index);
          }
        )
      );
    };

    const deleteRowSpracovatel = (index) => {
      for (let i = 0; i < watchers.value.length; i++) {
        watchers.value[i]();
      }
      watchers.value = [];

      form.value.spracovatelia.splice(index, 1);
      loading_administrator.value.splice(index, 1);
      items_administrator.value.splice(index, 1);
      search_administrator.value.splice(index, 1);

      search_administrator.value.forEach((_, val) => {
        const unwatch = watch(
          () => search_administrator.value[val],
          (newVal) => {
            querySelectionsAdministrator(newVal, val);
          }
        );
        watchers.value.push(unwatch);
      });
    };

    const deleteRowSpracovatelUPSVAR = (index) => {
      for (let i = 0; i < watchers_upsvar.value.length; i++) {
        watchers_upsvar.value[i]();
      }
      watchers_upsvar.value = [];

      form.value.spracovatelia_upsvar.splice(index, 1);
      loading_administrator_upsvar.value.splice(index, 1);
      items_administrator_upsvar.value.splice(index, 1);
      search_administrator_upsvar.value.splice(index, 1);

      search_administrator_upsvar.value.forEach((_, val) => {
        const unwatch = watch(
          () => search_administrator_upsvar.value[val],
          (newVal) => {
            querySelectionsAdministratorUPSVAR(newVal, val);
          }
        );
        watchers_upsvar.value.push(unwatch);
      });
    };

    onMounted(() => {
      getItem();
    });

    return {
      loading,
      form,      loading_administrator,
      search_administrator,
      loading_administrator_upsvar,
      search_administrator_upsvar,
      items_administrator,
      items_administrator_upsvar,
      select_administrator,
      select_administrator_upsvar,
      select_pracovna_pozicia,
      select_pracovna_pozicia_upsvar,
      isDirty,
      formActions,
      updateItem,
      addRow,
      addRowUPSVAR,
      deleteRowSpracovatel,
      deleteRowSpracovatelUPSVAR,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      if (window.confirm('Máte neuložené zmeny. Naozaj chcete odísť?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>